import { Fragment } from 'react';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import styled from 'styled-components';
import { useResponsiveProps } from '../../hooks/useResponsiveProps';
import * as ScreenSizes from '../constants/ScreenSizes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RightItemStyledWrapper = styled.div.withConfig({
  displayName: "MainSectionHeading__RightItemStyledWrapper",
  componentId: "r137vb-0"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  const {
    itemRightStyles
  } = useResponsiveProps({
    itemRightStyles: {
      [ScreenSizes.SM]: {
        marginTop: theme.space['200']
      },
      [ScreenSizes.MD]: {
        width: '100%',
        textAlign: 'right',
        marginTop: theme.space['1100']
      }
    }
  });
  return itemRightStyles;
});
export function MainSectionHeading({
  itemRight,
  subheading,
  children
}) {
  let renderedHeading = /*#__PURE__*/_jsx(Text, {
    as: "h2",
    marginBlockEnd: subheading ? '400' : '0',
    children: children
  });
  if (subheading) {
    renderedHeading = /*#__PURE__*/_jsxs(Fragment, {
      children: [renderedHeading, /*#__PURE__*/_jsx(Text, {
        as: "p",
        marginBlockEnd: "0",
        children: subheading
      })]
    });
  }
  if (itemRight) {
    return /*#__PURE__*/_jsxs(Grid, {
      marginBlockEnd: "400",
      children: [/*#__PURE__*/_jsx(GridItem, {
        size: {
          sm: 12,
          md: 8
        },
        children: renderedHeading
      }), /*#__PURE__*/_jsx(GridItem, {
        size: {
          sm: 12,
          md: 4
        },
        children: /*#__PURE__*/_jsx(RightItemStyledWrapper, {
          children: itemRight
        })
      })]
    });
  }
  return /*#__PURE__*/_jsx(View, {
    marginBlockEnd: "100",
    children: renderedHeading
  });
}